var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.836,0H2.164A2.164,2.164,0,0,0,0,2.164V27.836A2.164,2.164,0,0,0,2.164,30H27.836A2.164,2.164,0,0,0,30,27.836V2.164A2.164,2.164,0,0,0,27.836,0Zm-17.2,22.676H6.988V11.685h3.653ZM8.815,10.184H8.791a1.9,1.9,0,1,1,.048-3.8,1.9,1.9,0,1,1-.024,3.8Zm15,12.491H20.161V16.8c0-1.478-.529-2.485-1.851-2.485a2,2,0,0,0-1.874,1.336,2.5,2.5,0,0,0-.12.891v6.138H12.663s.048-9.96,0-10.991h3.653v1.556a3.627,3.627,0,0,1,3.292-1.814c2.4,0,4.206,1.571,4.206,4.947Zm0,0","transform":"translate(0 0)"}));
}

SocialLinkedin.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
